import { NgxPermissionsModule } from 'ngx-permissions';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbProgressbarModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InlineSVGModule } from 'ng-inline-svg';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreModule } from '../../core/core.module';
import { HeaderComponent } from './header/header.component';
import { AsideLeftComponent } from './aside/aside-left.component';
import { FooterComponent } from './footer/footer.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { BrandComponent } from './brand/brand.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { PartialsModule } from '../partials/partials.module';
import { BaseComponent } from './base/base.component';
import { PagesModule } from '../pages/pages.module';
import { HtmlClassService } from './html-class.service';
import { HeaderMobileComponent } from './header/header-mobile/header-mobile.component';
import { MatIconModule } from '@angular/material/icon';
import { ContextComponent } from 'src/app/components/context/context.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

var MaterialComponent = [
    MatIconModule,
    MatProgressBarModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatInputModule,
];

@NgModule({
    declarations: [
        BaseComponent,
        FooterComponent,
        HeaderComponent,
        BrandComponent,
        HeaderMobileComponent,
        SubheaderComponent,
        TopbarComponent,
        AsideLeftComponent,
        ContextComponent,
    ],
    exports: [
        BaseComponent,
        FooterComponent,
        HeaderComponent,
        BrandComponent,
        HeaderMobileComponent,
        SubheaderComponent,
        TopbarComponent,
        AsideLeftComponent,
    ],
    providers: [HtmlClassService],
    imports: [
        CommonModule,
        RouterModule,
        NgxPermissionsModule.forChild(),
        PagesModule,
        PartialsModule,
        CoreModule,
        PerfectScrollbarModule,
        FormsModule,
        MaterialComponent,
        TranslateModule.forChild(),
        LoadingBarModule,
        InlineSVGModule,
        NgbProgressbarModule,
        NgbTooltipModule,
    ],
})
export class ThemeModule {}
